module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-02-83ecd29f6b42b68b960c3484ebc6d89a.jpg";